import { useMutation } from '@tanstack/react-query';

import { request } from '@core/api/request';
import type { BillingInterval } from '@shared/types/plan';

export const subscribeToPlan = async ({
  id,
  billing_interval,
}: {
  id: number;
  billing_interval: BillingInterval;
}): Promise<{ session_url: string }> => {
  return await request({
    url: 'subscriptions/stripe-checkout/',
    method: 'POST',
    body: { billing_interval, plan_id: id },
  });
};

export const useSubscribeToPlan = () => {
  return useMutation({
    mutationFn: subscribeToPlan,
  });
};
